export { ForgotPasswordEmailSentEditable } from './ForgotPasswordEmailSent';
